// Keys the backend always attaches even when every section is empty
// (e.g. task aborted mid-generation) — they must not count as content.
const META_KEYS = ['sectionOrder', 'llmStartComments', 'llmEndComments'];

const valueHasContent = (value) => {
  if (value == null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.some(valueHasContent);
  if (typeof value === 'object') return Object.values(value).some(valueHasContent);
  return true;
};

export const noteHasContent = (note) => {
  if (note == null) return false;
  if (typeof note === 'string') {
    const t = note.trim();
    if (t === '' || t === 'null') return false;
    if (t.startsWith('{')) {
      try {
        return noteHasContent(JSON.parse(t));
      } catch {
        return true;
      }
    }
    return true;
  }
  if (typeof note === 'object') {
    return Object.entries(note).some(
      ([key, value]) => !META_KEYS.includes(key) && valueHasContent(value)
    );
  }
  return false;
};
